<template>
  <v-list-item prepend-icon="mdi-home" title="(C01) TOP PAGE" to="/TopPage" />
  <v-list-group v-if="hasAccessibleItems('MASTER')" value="MASTER TABLE">
    <template #activator="{ props }">
      <v-list-item v-bind="props" prepend-icon="mdi-account-circle" title="MASTER TABLE"></v-list-item>
    </template>
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('CALENDARCODE')"
      class="small"
      title="(A01) CALENDAR CODE"
      to="/CalendarCode"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('WORKINGCALENDAR')"
      class="small"
      title="(A02) WORKING CALENDAR"
      to="/WorkingCalendar"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('CORRESPONDENCECALENDAR')"
      class="small"
      title="(A03) CORRESPONDENCE CALENDAR"
      to="/CorrespondenceCalendar"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('EVENTMASTER')"
      class="small"
      title="(A04) EVENT CALENDAR"
      to="/EventMaster"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PARTMASTER')"
      class="small"
      title="(B01) PART MASTER"
      to="/PartMaster"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PAIRINGREGISTRATION')"
      class="small"
      title="(B02) PARING PART"
      to="/PairingRegistration"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('GROUPINGREGISTRATION')"
      class="small"
      title="(B03) GROUPING PART"
      to="/GroupingRegistration"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('COLLECTIVEVANNING')"
      class="small"
      title="(B04) COLLECTIVE VANNING"
      to="/CollectiveVanning"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('DISCONTINUEDPART')"
      class="small"
      title="(B05) DISCONTINUED PART"
      to="/DiscontinuedPart"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PACKINGCONDITIONMAINTENANCE')"
      class="small"
      title="(D01) PACKING CONDITION MAINTENANCE"
      to="/PackingConditionMaintenance"
    />
  </v-list-group>
  <v-list-group v-if="hasAccessibleItems('PXP_ORDER')" value="PXP ORDER COMPILING">
    <template #activator="{ props }">
      <v-list-item v-bind="props" prepend-icon="mdi-account-circle" title="PXP ORDER COMPILING"></v-list-item>
    </template>
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('ORDERVOLATILITYSEARCH')"
      class="small"
      title="(I01) ORDER VOLATILITY SEARCH"
      to="/OrderVolatilitySearch"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('ORDERCOMPILING')"
      class="small"
      title="(I02) ORDER COMPILING"
      to="/OrderCompiling"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('ORDERPLANHISTORY')"
      class="small"
      title="(I03) ORDER/PLAN HISTORY"
      to="/OrderPlanHistory"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('BOMCHECKLIST')"
      class="small"
      title="(I04) BOM CHECK LIST"
      to="/BomCheckList"
    />
  </v-list-group>

  <v-list-group v-if="hasAccessibleItems('PACKING_PLAN')" value="PACKING PLAN BUILDING">
    <template #activator="{ props }">
      <v-list-item v-bind="props" prepend-icon="mdi-account-circle" title="PACKING PLAN BUILDING"></v-list-item>
    </template>
    <v-list-item
      v-if="
        authStore.getAccessPrivilegeByPageKey('PACKINGPLAN') ||
        authStore.getAccessPrivilegeByPageKey('PACKINGPLANMONTHLY') ||
        authStore.getAccessPrivilegeByPageKey('PACKINGPLANWEEKLY')
      "
      class="small"
      title="(J01) PACKING PLAN"
      to="/PackingPlan"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('REPORTOUTPUT')"
      class="small"
      title="(K01) REPORT OUTPUT"
      to="/ReportOutput"
    />
  </v-list-group>
  <v-list-group v-if="hasAccessibleItems('RESULT_ADMIN')" value="RESULT ADMINISTRATION">
    <template #activator="{ props }">
      <v-list-item v-bind="props" prepend-icon="mdi-account-circle" title="RESULT ADMINISTRATION"></v-list-item>
    </template>
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PACKINGPROGRESS')"
      class="small"
      title="(L01) PACKING PROGRESS"
      to="/PackingProgress"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PACKINGINFORMATION')"
      class="small"
      title="(L02) PACKING INFORMATION"
      to="/PackingInformation"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('CASEINFORMATION')"
      class="small"
      title="(L03) CASE INFORMATION"
      to="/CaseInformation"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('ORDEROCFASN')"
      class="small"
      title="(L04) ODR-OCF-ASN HISTORY"
      to="/OrderOcfAsn"
    />
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('PACKINGRESULTSMAINTENANCE')"
      class="small"
      title="(D02) PACKING RESULT MAINTENANCE"
      to="/PackingResultsMaintenance"
    />
  </v-list-group>
  <v-list-group v-if="hasAccessibleItems('JOB_NET')" value="JOB NET KICK">
    <template #activator="{ props }">
      <v-list-item v-bind="props" prepend-icon="mdi-account-circle" title="JOB NET KICK"></v-list-item>
    </template>
    <v-list-item
      v-if="authStore.getAccessPrivilegeByPageKey('JOBNETKICK')"
      prepend-icon="mdi-file-outline"
      class="small"
      title="(M01) JOB NET KICK"
      to="/JobNetKick"
    />
  </v-list-group>
</template>

<script lang="ts">
import { useAuthStore } from '@/stores/auth';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SideBarItems',
  setup() {
    const authStore = useAuthStore();
    const hasAccessibleItems = (groupKey: string) => {
      switch (groupKey) {
        case 'MASTER':
          return (
            authStore.getAccessPrivilegeByPageKey('CALENDARCODE') ||
            authStore.getAccessPrivilegeByPageKey('WORKINGCALENDAR') ||
            authStore.getAccessPrivilegeByPageKey('CORRESPONDENCECALENDAR') ||
            authStore.getAccessPrivilegeByPageKey('EVENTMASTER') ||
            authStore.getAccessPrivilegeByPageKey('PARTMASTER') ||
            authStore.getAccessPrivilegeByPageKey('PAIRINGREGISTRATION') ||
            authStore.getAccessPrivilegeByPageKey('GROUPINGREGISTRATION') ||
            authStore.getAccessPrivilegeByPageKey('COLLECTIVEVANNING') ||
            authStore.getAccessPrivilegeByPageKey('DISCONTINUEDPART') ||
            authStore.getAccessPrivilegeByPageKey('PACKINGCONDITIONMAINTENANCE')
          );

        case 'PXP_ORDER':
          return (
            authStore.getAccessPrivilegeByPageKey('ORDERVOLATILITYSEARCH') ||
            authStore.getAccessPrivilegeByPageKey('ORDERCOMPILING') ||
            authStore.getAccessPrivilegeByPageKey('ORDERPLANHISTORY') ||
            authStore.getAccessPrivilegeByPageKey('BOMCHECKLIST')
          );

        case 'PACKING_PLAN':
          return (
            authStore.getAccessPrivilegeByPageKey('PACKINGPLAN') ||
            authStore.getAccessPrivilegeByPageKey('PACKINGPLANMONTHLY') ||
            authStore.getAccessPrivilegeByPageKey('PACKINGPLANWEEKLY') ||
            authStore.getAccessPrivilegeByPageKey('REPORTOUTPUT')
          );

        case 'RESULT_ADMIN':
          return (
            authStore.getAccessPrivilegeByPageKey('PACKINGPROGRESS') ||
            authStore.getAccessPrivilegeByPageKey('PACKINGINFORMATION') ||
            authStore.getAccessPrivilegeByPageKey('CASEINFORMATION') ||
            authStore.getAccessPrivilegeByPageKey('ORDEROCFASN') ||
            authStore.getAccessPrivilegeByPageKey('PACKINGRESULTSMAINTENANCE')
          );

        case 'JOB_NET':
          return authStore.getAccessPrivilegeByPageKey('JOBNETKICK');

        default:
          return false;
      }
    };
    return {
      authStore,
      hasAccessibleItems,
    };
  },
});
</script>
